import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37db4f3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xl-18 ant-col-xs-18" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xl-3 ant-col-xs-6 ant-col-lg-6" }, null, -1))
const _hoisted_4 = {
  class: "ant-col ant-col-xl-3 ant-col-xs-3 ss-ocultar-mobile",
  style: {"padding-right":"10px"}
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 2,
  class: "acoes-item"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = { key: 5 }
const _hoisted_12 = {
  key: 6,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  class: "ant-row",
  style: {"padding":"10px"}
}
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_17 = {
  class: "ant-input-affix-wrapper ss-paginacao-qtde-registros",
  style: {"margin-top":"0px"}
}
const _hoisted_18 = { class: "ant-input-suffix" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Limite total de registros. Lembre-se: Quanto menor a quantidade de registros mais rápido o seu resultado será apresentado.", -1))
const _hoisted_20 = {
  tabindex: "-1",
  role: "img",
  "aria-label": "info-circle",
  class: "anticon anticon-info-circle",
  style: {"color":"rgba(0, 0, 0, 0.45)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_coluna_grade = _resolveComponent("coluna-grade")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_radio_group, {
          value: _ctx.computedVisualizacaoKanban,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedVisualizacaoKanban) = $event)),
          "button-style": "solid"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_button, {
              value: true,
              style: {"padding-top":"5px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_icone, { nome: "mapa" })
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, {
              value: false,
              style: {"padding-top":"5px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_icone, { nome: "menu" })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    _createVNode(_component_a_table, {
      style: {"margin-top":"5px"},
      columns: _ctx.state.colunas.filter(item => item.visible),
      "data-source": _ctx.computedDevolucoes,
      rowKey: "codigo",
      pagination: false,
      loading: _ctx.telaBase.carregando,
      scroll: _ctx.state.telaMobile ? null : { y: _ctx.window.innerHeight },
      "row-selection": { selectedRowKeys: _ctx.computedSelecionados, onChange: _ctx.mudarSelecao },
      size: "small"
    }, {
      headerCell: _withCtx(({ column }) => [
        _createVNode(_component_coluna_grade, {
          column: column,
          ordenacaoSelecionada: _ctx.telaBase.ordenacaoSelecionada,
          "onUpdate:ordenacaoSelecionada": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.telaBase.ordenacaoSelecionada) = $event)),
          filtrosCabecalho: _ctx.gradeBase.filtrosCabecalho,
          "onUpdate:filtrosCabecalho": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.gradeBase.filtrosCabecalho) = $event)),
          onBuscarDados: _ctx.buscarDevolucoes
        }, null, 8, ["column", "ordenacaoSelecionada", "filtrosCabecalho", "onBuscarDados"])
      ]),
      bodyCell: _withCtx(({ column, text, index, record }) => [
        (column.customRenderRow === _ctx.ECustomRenderRow.LinkAcao)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: ($event: any) => (_ctx.visualizar(index))
            }, [
              _createElementVNode("span", null, _toDisplayString(text), 1)
            ], 8, _hoisted_5))
          : (column.key === 'Status')
            ? (_openBlock(), _createBlock(_component_a_tag, {
                key: 1,
                class: _normalizeClass('ss-tag-status ' + _ctx.obterClasseStatus(text))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(text), 1)
                ]),
                _: 2
              }, 1032, ["class"]))
            : (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("a", {
                    class: "visualizar",
                    onClick: ($event: any) => (_ctx.visualizar(index))
                  }, [
                    _createVNode(_component_icone, { nome: "visualizar" })
                  ], 8, _hoisted_7),
                  _createElementVNode("a", {
                    class: "imprimir",
                    onClick: ($event: any) => (_ctx.imprimir(index))
                  }, [
                    _createVNode(_component_icone, { nome: "imprimir" })
                  ], 8, _hoisted_8)
                ]))
              : (column.customRenderRow === _ctx.ECustomRenderRow.MascararCPFCNPJ)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(text)), 1))
                : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                  : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text)), 1))
                    : (column.key === 'DevolucaoCompras')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("span", null, [
                            _createElementVNode("b", null, [
                              _createElementVNode("a", {
                                onClick: ($event: any) => (_ctx.visualizar(index))
                              }, [
                                _createElementVNode("span", null, "Devolução " + _toDisplayString(record.numero), 1)
                              ], 8, _hoisted_13)
                            ])
                          ]),
                          _createElementVNode("span", null, "Nota " + _toDisplayString(record.numeroNotaFiscal) + " do dia " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinutoSegundo(record.dataEmissao)), 1),
                          _createElementVNode("span", null, _toDisplayString(record.nomeRazaoSocialEmitente), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.totalNotaFiscal, 2)), 1),
                          _createElementVNode("span", null, [
                            _createVNode(_component_a_tag, {
                              class: _normalizeClass('ss-tag-status ' + _ctx.obterClasseStatus(record.descricaoStatus))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(record.descricaoStatus), 1)
                              ]),
                              _: 2
                            }, 1032, ["class"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
      ]),
      emptyText: _withCtx(() => [
        _createVNode(_component_mensagem_sem_dados, {
          resultadoPesquisa: !_ctx.telaBase.carregando,
          mensagem: _ctx.telaBase.carregando ? 'Buscando informações, por favor aguarde...' : 'Nenhum registro foi encontrado com estes filtros!'
        }, null, 8, ["resultadoPesquisa", "mensagem"])
      ]),
      _: 1
    }, 8, ["columns", "data-source", "loading", "scroll", "row-selection"]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_a_pagination, {
          class: "ss-paginacao-completa",
          current: _ctx.computedPaginacao.current,
          "onUpdate:current": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedPaginacao.current) = $event)),
          size: "small",
          total: _ctx.state.paginacaoApi.totalRegistros,
          "show-total": _ctx.mostrarTotalPaginacao,
          "page-size": _ctx.computedPaginacao.pageSize,
          pageSizeOptions: _ctx.computedPaginacao.pageSizeOptions,
          onShowSizeChange: _ctx.mostrarNovaPagina,
          onChange: _ctx.mudarPagina
        }, null, 8, ["current", "total", "show-total", "page-size", "pageSizeOptions", "onShowSizeChange", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("span", _hoisted_17, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.totalRegistrosComMascara) = $event)),
            onKeyup: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.keyupQuantidadeRegistroTotal && _ctx.keyupQuantidadeRegistroTotal(...args))),
            placeholder: "Total registros",
            type: "text",
            class: "ant-input hidden"
          }, null, 544), [
            [_vModelText, _ctx.state.totalRegistrosComMascara],
            [_directive_maska, _ctx.UtilitarioMascara.formatoMascaraNumeroInteiro]
          ]),
          _createElementVNode("span", _hoisted_18, [
            _createVNode(_component_a_tooltip, { placement: "top" }, {
              title: _withCtx(() => [
                _hoisted_19
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_20, [
                  _createVNode(_component_icone, { nome: "informacoes" })
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}